export default __webpack_public_path__ + "static/media/ic_noimage.18a602fc.svg";